<template>
  <loader v-if="dataLoading" />
  
  <div class="page">

    <div class="flex justify-content-center align-items-center">
      <div class="grid">
        <div class="grid">
          <div class="col p-as-end">
            <i></i><br>

            <i class="pi pi-filter mr-2" />
            <div class="field p-input-icon-left">
              <div class="field-radiobutton">
                <div class="wrap-radiobutton">

                  <span class="flex flex-row align-items-center m-2">
                    <prime-radio-button 
                      name="filterByYear" 
                      :value="0" 
                      v-model="filter.selected" 
                      
                      @change="onChangeTypeFilter"

                      class="mr-2" />
                    <input-number 
                      v-model="filter.year" 
                      showButtons buttonLayout="horizontal" 
                      inputStyle="text-align:center;"
                      
                      :step="1"
                      decrementButtonClass="p-button-danger" 
                      incrementButtonClass="p-button-success" 
                      
                      incrementButtonIcon="pi pi-plus" 
                      decrementButtonIcon="pi pi-minus"

                      :useGrouping="false"

                      :disabled="filter.selected != 0"
                    />
                  </span>

                  <span class="flex flex-row align-items-center m-2">
                    <prime-radio-button 
                      name="filterByDates" 
                      :value="1" 
                      v-model="filter.selected" 
                      
                      @change="onChangeTypeFilter"

                      class="mr-2" />
                    <calendar 
                      v-model="filter.startDate" 
                      :showIcon="true" 
                      dateFormat="dd/mm/yy"

                      :disabled="filter.selected != 1"

                      class="inputfield w-full mr-2"
                    />
                    <calendar 
                      v-model="filter.stopDate" 
                      :showIcon="true" 
                      dateFormat="dd/mm/yy"

                      :disabled="filter.selected != 1"

                      class="inputfield w-full mr-2"
                    />
                    <prime-button 
                      icon="pi pi-search" 
                      class="p-button-rounded m-2" 

                      :disabled="filter.selected != 1 || ( filter.startDate == null && filter.stopDate == null )"

                      @click="onApplyFilter"
                    />
                  </span>

                </div>
              </div>
            </div>

            <span class="flex justify-content-center align-items-center">
              <prime-button 
                icon="pi pi-filter-slash" 
                class="p-button-rounded m-2" 

                @click="onResetFilter"
              />
            </span>
            
          </div>
        </div>
      </div>
    </div>

    <accordion :multiple="true" >
      <accordion-tab v-for="(item, name) in data.saldi" :key="name">
        <template #header>
          <span>{{ name.split('_').map(el => el.charAt(0).toUpperCase() + el.slice(1)).join(' ') }}</span>
        </template>

        <div class="formgrid grid">
          <div class="field col-12 md:col-4">
            <label for="ragsoc">Fatturato</label>
            <input-number 
              v-model="item.totale_fatturato"  
              mode="currency" currency="EUR" locale="it-IT"
              :disabled="true"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="ragsoc">Pagato</label>
            <input-number 
              v-model="item.totale_pagato"  
              mode="currency" currency="EUR" locale="it-IT"
              :disabled="true"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="ragsoc">Saldo</label>
            <input-number 
              v-model="item.totale_saldo"  
              mode="currency" currency="EUR" locale="it-IT"
              :disabled="true"
            />
          </div>
        </div>

        <data-table 
          :value="item.dettagli" 
          dataKey="id"
          
          :paginator="true" 
          :rows="10"
          :rowsPerPageOptions="[10,20,50]" 
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords}"

          responsiveLayout="scroll"
        >
          <column field="ragsoc" header="Ragione Sociale"></column>
          <column field="piva" header="Partita Iva"></column>
          <column field="codfis" header="Codice Fiscale"></column>
          <column field="fatturato" header="Fatturato">
            <template #body="{data}">
              {{currencyFormatter.format( (data.fatturato !== null)? data.fatturato: 0 )}}
            </template>
          </column>
          <column field="pagato" header="Pagato">
            <template #body="{data}">
              {{currencyFormatter.format( (data.pagato !== null)? data.pagato: 0 )}}
            </template>
          </column>
          <column field="saldo" header="Saldo">
            <template #body="{data}">
              {{currencyFormatter.format( (data.saldo !== null)? data.saldo: 0 )}}
            </template>
          </column>
        </data-table>

      </accordion-tab>
    </accordion>
    
  </div>
</template>

<script>
import moment from 'moment'

import Service from '@/services/ask-management/utility-bilancio-service'

import Loader from '@/components/Loader.vue'
import PrimeButton from 'primevue/button'
import PrimeRadioButton from 'primevue/radiobutton'

export default { 
  components: {
    Loader,
    PrimeButton,
    PrimeRadioButton,
  },

  data() {
    return {
      moment,

      currencyFormatter: new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
      }),

      dataLoading: false,
      
      filter: {
        types: [
          'byYear',
          'byDates',
        ],
        selected: 1,

        year: new Date().getFullYear(),
        startDate: null,
        stopDate: new Date(),
      },

      data: {
        saldi: {}
      },
    }
  },

  created(){
    this.service = new Service(this.$http, this.$eventBus)
    this.getSaldiByDate()
  },

  methods:{

    onResetFilter(){
      this.filter.selected = 1

      this.filter.year = new Date().getFullYear()
      this.filter.startDate = null
      this.filter.stopDate = new Date()

      this.getSaldiByDate()
    },

    onChangeTypeFilter(){
      switch (this.filter.selected) {
        case 0:
          this.changeDates(this.filter.year)
          this.getSaldiByYear()
          break;
      
        default:
          break;
      }
    },

    onApplyFilter(){
      this.getSaldiByDate()
    },

    /////

    navigateToTab(href){
      window.open(href, '_blank')
    },

    changeDates(year){
      const date = new Date(year, 0, 1)
      this.filter.startDate = date
      this.filter.stopDate = moment(date).endOf('year').toDate()
    },

    getSaldiByYear(){
      this.dataLoading = true

      this.service.getSaldiByYear(this.filter.year).then((res) => {
        this.data.saldi = res.item
      }).finally(() =>{
        this.dataLoading = false
      })
    },

    getSaldiByDate(){
      this.dataLoading = true

      let start = null
      if(this.filter.startDate != null){
        start =  moment(this.filter.startDate).format('YYYY-MM-DD')
      }
      const stop =  moment(this.filter.stopDate).format('YYYY-MM-DD')

      this.service.getSaldiByDate({
        start_date: start,
        stop_date: stop,
      }).then((res) => {
        this.data.saldi = res.item
      }).finally(() =>{
        this.dataLoading = false
      })
    }

  },

  computed:{
    
  },

  watch: {
    'filter.year': {
      handler(newValue) {
        if(this.filter.selected == 0){
          this.changeDates(newValue)
          this.getSaldiByYear()
        }
      }
    },

    'filter.stopDate': {
      handler(newValue) {
        if(this.filter.selected == 1){
          if(newValue != null){
            this.filter.year = newValue.getFullYear()
          }
        }
      }
    },
  },
}
</script>

<style scoped>
.box-center{
  text-align: center;
}
</style>
